import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_side-layout/actions/profiles/')({
  beforeLoad: () => {
    throw redirect({ to: '/actions/profiles/profiles' });
  },
});
